import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { activeFacebookPageIdSelector } from '@mm/state/selectors/viewSelectors';
import { useModalActions } from '@mm/state/modules/modalsState/actions';
import { useSlackCRUDActions } from '@mm/state/actions/SlackCRUDActions';
import { selectSlackAccounts } from '@mm/state/selectors/slackSelectors';
import { landmineNames } from '@mm/constants/landmine-names';
import { PageBillingType } from '@mm/state/interfaces/connected-page';
import { SlackHeaderComponent } from './SlackHeaderComponent';
import { AccordionItem } from '@mm/components';
import {
  ButtonColor,
  PrimaryButton,
} from '../../../../../../../../common/buttons/PrimaryButton/PrimaryButton';

export const SlackIntegrations = () => {
  const facebookPageId = useSelector(activeFacebookPageIdSelector);
  const accounts = useSelector(selectSlackAccounts);
  const { getAccounts, disconnectAccount } = useSlackCRUDActions();
  const { openGeneralConfirmModal } = useModalActions();
  const { openUniversalUpgradeLandmineModal } = useModalActions();

  useEffect(() => {
    getAccounts(facebookPageId);
  }, []);

  const showUpgradeModal = (onSuccessBilling: () => void) => {
    openUniversalUpgradeLandmineModal({
      landmineName: landmineNames.INTEGRATIONS_NATIVE_INTEGRATIONS,
      feature: 'nativeIntegrations',
      planFallback: PageBillingType.ProUnicorn,
      onSuccessBilling,
    });
  };

  const onDisconnect = (accountId: number) => {
    const teamName = accounts?.find(acc => acc.id === accountId)?.teamName;
    openGeneralConfirmModal({
      headerText: `Are you sure you want to disconnect ${teamName} account from Slack Notifications?`,
      messageText: '',
      onCloseHandler: ok => {
        if (ok) {
          disconnectAccount(accountId, facebookPageId);
        }
      },
      okButtonText: 'Disconnect',
      okButtonStyling: { red: true },
      cancelButtonText: 'Cancel',
      cancelButtonFirst: true,
      css: {
        primaryButton: 'integrations__diconnect-modal-primary-button',
        secondaryButton: 'integrations__confirm-modal-secondary-button',
      },
    });
  };

  const headerComponent = (
    <SlackHeaderComponent
      isAccountConnected={!!accounts.length}
      accountsCount={accounts.length}
      showUpgradeModal={showUpgradeModal}
    />
  );

  return (
    <div className="integrations-component">
      <AccordionItem
        className="integrations-item"
        caretStyleIcon
        closeOnOutsideClick={false}
        openOnMount
        titleComponent={headerComponent}
      >
        {!!accounts.length && (
          <div className="integrations-item__your-accounts">
            <table className="integrations-item__table">
              <thead>
                <th>Slack Workspace</th>
                <th>Actions</th>
              </thead>
              <tbody>
                {accounts.map(account => (
                  <tr key={account.id} style={{ height: '48px' }}>
                    <td>{account.teamName}</td>

                    <td className="integrations__three-dot-menu-wrapper">
                      <PrimaryButton
                        className="integrations__header-add-button-secondary"
                        onClick={() => onDisconnect(account.id)}
                        color={ButtonColor.secondaryBlue}
                      >
                        Disconnect
                      </PrimaryButton>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </AccordionItem>
    </div>
  );
};
